(function() {
  const videoButton = document.querySelector('.videoModule__button'),
        videoSection = document.querySelector('.videoModule'),
        popupVideos = document.querySelectorAll('.videoModule__popupWrapper video');

  function openVideo() {
    videoSection.classList.add('videoModule--active');
    if (popupVideos.length > 1) {
      if (window.innerWidth <= 768) {
        let mobileVideo = document.querySelector('.videoModule__popup--mobile');

        mobileVideo.play();
      } else {
        let desktopVideo = document.querySelector('.videoModule__popup--desktop');

        desktopVideo.play();
      }
    } else {
      popupVideos.forEach(video => {
        video.play();
      });
    }
  }

  videoButton.addEventListener('click', openVideo);
})();
